import {MessageNode} from "../messageObject/MessageNode.ts";

const sharedChatMessageIdMapping: { [key: string]: MessageNode } = {};

export default sharedChatMessageIdMapping;